export const TID = {
  nav: {
    root: "nav-root",
    logo: "nav-logo",
    logoMark: "nav-logo-mark",
    linkServer: "nav-link-server",
    linkFeatures: "nav-link-features",
    linkFactions: "nav-link-factions",
    linkGallery: "nav-link-gallery",
    linkFaq: "nav-link-faq",
    discord: "nav-cta-discord",
    join: "nav-cta-join",
    serverStatus: "nav-server-status",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    root: "hero-root",
    title: "hero-title",
    subtitle: "hero-subtitle",
    ctaJoin: "hero-cta-join",
    ctaDiscord: "hero-cta-discord",
    scrollHint: "hero-scroll-hint",
  },
  stats: {
    root: "stats-root",
    card: (k) => `stat-card-${k}`,
  },
  features: {
    root: "features-root",
    card: (k) => `feature-card-${k}`,
  },
  factions: {
    root: "factions-root",
    item: (k) => `faction-item-${k}`,
  },
  gallery: {
    root: "gallery-root",
    item: (k) => `gallery-item-${k}`,
  },
  faq: {
    root: "faq-root",
    item: (k) => `faq-item-${k}`,
  },
  footer: {
    root: "footer-root",
    discord: "footer-link-discord",
    join: "footer-link-join",
  },
};
